import { render, staticRenderFns } from "./AssignedTechnicianItem.vue?vue&type=template&id=0596e544&"
import script from "./AssignedTechnicianItem.vue?vue&type=script&lang=js&"
export * from "./AssignedTechnicianItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports